import { Component, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ApiService } from '../../services/api/api.service';
import { LoaderService } from '../../services/misc/loader/loader.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { MatDialog } from '@angular/material/dialog';
import { AddThingsDialogComponent } from 'src/app/dialogs/add-things-dialog/add-things-dialog.component';
import { ChangePasswordDialogComponent } from 'src/app/dialogs/change-password-dialog/change-password-dialog.component';
import { ViewProfileDialogComponent } from 'src/app/dialogs/view-profile-dialog/view-profile-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent {
  isDarkTheme: boolean = false;
  isOpen: boolean = true;
  opened: boolean = true;
  isHandSet: boolean = false;
  isSmall: boolean = false;
  isLoading: boolean = false;
  selectedRoute: 'dashboard' | 'devicelist' | 'devicedetails' | 'account' =
    'dashboard';

  //Breakpoint handler for nav behaviour
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.Handset])
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  isSmall$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.Large])
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private api: ApiService,
    public loaderService: LoaderService,
    public globals: GlobalsService,
    public dialog: MatDialog,
    public router: Router
  ) {}

  ngOnInit() {
    let me = this;
    if (window.innerWidth < 600) {
      me.isHandSet = true;
      // console.log(window.innerWidth);
    }
    //Get dark theme preference
    this.isDarkTheme = localStorage.getItem('theme') === 'dark' ? true : false;

    //Set breakpoint option value
    this.isHandset$.subscribe((currentValue) => {
      this.isHandSet = currentValue;
      this.globals.isHandSet = currentValue;
      // console.log(currentValue)
    });

    this.isSmall$.subscribe((currentValue) => {
      this.isSmall = currentValue;
      this.globals.isSmall = currentValue;
      // console.log(this.isSmall)
      //Check screenwidth
      // console.log(currentValue)
    });

    this.api.doCheckToken();
  }

  storeThemeSelection() {
    //Set theme
    localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light');
  }

  toggleNav() {
    //Toggle nav behaviour
    this.isOpen = !this.isOpen;
  }

  // selectClass(selectedClass: "dashboard" | "users" | "things" | "groups") {
  //   this.selectedRoute = selectedClass;

  //   let unCapped = selectedClass;
  //   let capped: any = unCapped.charAt(0).toUpperCase() + unCapped.substring(1);
  //   this.globals.selectedSidenav = capped;
  // }

  doNav(
    selectedClass: 'dashboard' | 'devicelist' | 'devicedetails' | 'account'
  ) {
    //Only nav if loading is done
    if (selectedClass != 'devicelist') {
      this.globals.selectedRoute = selectedClass;

      this.router.navigate([selectedClass]);
    } else if (!this.globals.devicesLoading) {
      this.globals.selectedRoute = selectedClass;

      this.router.navigate([selectedClass]);
    }
  }

  viewProfile() {
    const dialogRef = this.dialog.open(ViewProfileDialogComponent, {
      width: '640px',
      disableClose: false,
      backdropClass: 'bdrop',
    });
  }

  logout() {
    localStorage.setItem('lastpage', null);

    this.api.logout(
      () => {
        //TODO: Route to login
        this.globals.currentview = 'login';
      },
      () => {
        this.globals.currentview = 'login';
      }
    );
  }
}
